<div class="password">
    <input type="text" class="app-input" [value]="value" [placeholder]="placeholder || ''"
    [attr.disabled]="isDisabled ? true : null" (keyup)="onKeyup($event.target.value)" (blur)="onBlur()" 
    [attr.type]="passwordType" autocomplete="new-password">

    <div class="password__actions" (click)="togglePassword()">
        <span>{{passwordType === 'password' ? 'Show' : 'Hide'}}</span>
    </div>
</div>
